import React, { useState, useEffect } from "react";
import { Nav } from "react-bootstrap";
import { sidebarItems } from "./SidebarData";
import { LogOut } from "lucide-react";
import { lightPrimary, primary } from "../../constants/colors";
import { useNavigate, useLocation } from "react-router-dom";

const Sidebar = () => {
  const [activeKey, setActiveKey] = useState("home");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Get current path without trailing slash
    const currentPath = location.pathname.endsWith('/')
      ? location.pathname.slice(0, -1)
      : location.pathname;

    // Find exact matching sidebar item based on current path
    const matchingItem = sidebarItems.find(item => {
      const itemPath = item.url.endsWith('/')
        ? item.url.slice(0, -1)
        : item.url;
      return currentPath === itemPath;
    });

    if (matchingItem) {
      setActiveKey(matchingItem.module);
    }
  }, [location.pathname]);

  return (
    <>
      <div
        className="d-none d-lg-flex d-xl-flex flex-column d-sm-none bg-white border-end position-fixed"
        style={{
          height: "100vh",
          width: "90px",
          overflowY: "auto",
          position: "fixed",
          top: 60,
        }}
      >
        <Nav
          className="flex-column align-items-center pt-3"
          activeKey={activeKey}
          onSelect={(selectedKey) => setActiveKey(selectedKey)}
        >
          {sidebarItems.map((item) => (
            <Nav.Item key={item.id} className="my-2">
              <Nav.Link
                onClick={() => navigate(item.url)}
                eventKey={item.module}
                className="d-flex flex-column align-items-center p-2"
                style={{
                  borderRadius: "4px",
                  border:
                    activeKey === item.module ? `2px solid ${primary}` : "none",
                  width: "70px",
                  height: "65px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  background: activeKey === item.module ? lightPrimary : "#fff",
                }}
              >
                <item.icon
                  size={16}
                  className={
                    activeKey === item.module ? "mainColor" : "text-secondary"
                  }
                />
                <span
                  className={`${
                    activeKey === item.module ? "mainColor" : "text-secondary"
                  } mt-1`}
                  style={{
                    fontSize: "11px",
                    fontWeight: "bold",
                  }}
                >
                  {item.label}
                </span>
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>

        <div className="mt-auto mb-5 pb-3">
          <div className="d-flex flex-column align-items-center">
            <div
              className="rounded-circle overflow-hidden mb-2"
              style={{ width: "40px", height: "40px" }}
            >
              {/* Profile image placeholder */}
            </div>
            <Nav.Link
              className="d-flex flex-column align-items-center p-2"
              href="/logout"
            >
              <LogOut size={24} className="text-secondary" />
              <span
                className="text-secondary mt-1"
                style={{ fontSize: "0.7rem" }}
              >
                Logout
              </span>
            </Nav.Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;